import { render, staticRenderFns } from "./company-pricing.vue?vue&type=template&id=70a52416&scoped=true&lang=pug"
import script from "./company-pricing.vue?vue&type=script&lang=ts"
export * from "./company-pricing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a52416",
  null
  
)

export default component.exports